/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import type { ThirdPartyOrganization } from 'bundles/admin-dashboard/types';

import AdminHeaderAndNav from './AdminHeaderAndNav';

type Props = {
  thirdPartyOrganization: ThirdPartyOrganization;
};

export const AdminAuthNavigation: React.FC<Props> = ({ thirdPartyOrganization }) => {
  return (
    <div
      css={css`
        min-height: 66px;
      `}
    >
      <nav
        className="rc-AdminAuthNavigation"
        css={css`
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 3000;
        `}
      >
        {isAuthenticatedUser() && <AdminHeaderAndNav thirdPartyOrganization={thirdPartyOrganization} />}
      </nav>
    </div>
  );
};
